module.exports = __webpack_public_path__ + "static/media/마.2bc0a3a7.jpg";